import Dashboard from "../../../components/CreateSubscription/Subscription";

export default function Card() {
  return (
    <>
      <Dashboard />
    </>
  );
}
